import { Component, OnInit, Input } from '@angular/core';
import { Utilerias } from 'src/app/helpers/Utilerias';
declare var $: any;

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrls: ['./crud.component.css']
})

export class CrudComponent implements OnInit {
  @Input() config: ConfigCrud;
  constructor() { }
  ngOnInit() {
    this.bind();
    let clearInputs = this.config.model.filter(x => x.isInput);

    $("#modalNuevo").on('hidden.bs.modal', function () {
      for (let item of clearInputs) {
        $('#Acciones-new-' + item.key).val('');
      }
    });
  }
  custom(idEmpleado) {
    $('#exampleModal').modal('show');
  }
  bind() {
    this.config.crudHttp.get()
      .then(res => {
        this.config.collection = res;
        Utilerias.showLoader(false);
      });
  }

  openModalNuevaAccion() {
    $("#modalNuevo").modal('show');
  }
  formNew(e: Event) {
    e.preventDefault();
    let objPost = {};
    if (this.config.crudHttp.paramPost) {
      objPost = this.config.crudHttp.paramPost;
    }
    for (let item of this.config.model.filter(x => x.isInput)) {
      objPost[item.key] = $('#' + this.config.crudId + '-new-' + item.key).val();
    }
    this.config.crudHttp.post({
      t: objPost
    })
      .then(newObj => {
        this.config.collection.push(newObj);
        $('#modalNuevo').modal('hide');
        Utilerias.showLoader(false);
      });
  }
  formEdit(e: Event) {
    e.preventDefault();
    this.config.crudHttp.put({
      t: this.config.itemEdit
    })
      .then(res => {
        for (let item of this.config.collection) {
          if (item[this.config.primaryKey] == res[this.config.primaryKey]) {
            item = res;
            break;
          }
        }
        $('#modalEditar').modal('hide');
        Utilerias.showLoader(false);
      })
  }
  edit(itemEdit) {
    this.config.itemEdit = itemEdit;
    $('#modalEditar').modal('show');
  }
  delete(item) {
    Utilerias.alertConfirm('¿Deseas eliminar el elemento?')
      .then(res => {
        if (res.value) {
          let obj = {};
          obj[this.config.labelDelete] = item[this.config.primaryKey];
          this.config.crudHttp.delete(obj)
            .then(() => {
              this.config.collection = this.config.collection
                .filter(x => x[this.config.primaryKey] != item[this.config.primaryKey]);
              Utilerias.showLoader(false);
            })
        };
      });
  }
  objectKeys(obj) {
    return Object.keys(obj);
  }

  filter(collection, key) {
    return collection.filter(x => x[key]);
  }
  setLabel(obj) {
    if (obj.label) return obj.label
    else return obj.key
  }
  closeModal(id) {
    $(id).modal('hide');
  }
}

export interface ConfigCrud {
  title: string;
  primaryKey: string;
  crudHttp: any;
  model: modelCrud[];
  collection?: object[];
  labelDelete?: string;
  itemEdit?: object;
  hidePost?: boolean;
  hideDelete?: boolean;
  crudId: string;
}

export interface modelCrud {
  key: string;
  label?: string;
  isInput?: boolean;
  inputType?: string;
  isRequired?: boolean;
  isTextArea?: boolean;
  customCell?: any;
}

